import { PP_ADMIN_REFERRER, PP_ADMIN_TOKEN } from "../constants/storageKeys";
import resources from "../constants/resources";
import { apiUrl } from "./dataProvider";

export default {
  // called when the user attempts to log in
  login: ({ token, referrer }) => {
    localStorage.setItem(PP_ADMIN_REFERRER, referrer);
    localStorage.setItem(PP_ADMIN_TOKEN, token);
    // accept all username/password combinations
    return Promise.resolve();
  },
  // called when the user clicks on the logout button
  logout: () => {
    const request = new Request(
      `${apiUrl}/${resources.LOGOUT.url}/?jwt=${localStorage.getItem(
        PP_ADMIN_TOKEN
      )}`,
      {
        method: "POST",
      }
    );
    fetch(request).finally(() => localStorage.removeItem(PP_ADMIN_TOKEN));
    return Promise.resolve();
  },
  // called when the API returns an error
  checkError: ({ status }) => {
    if (status === 401 || status === 403) {
      localStorage.removeItem(PP_ADMIN_TOKEN);
      return Promise.reject();
    }
    return Promise.resolve();
  },
  // called when the user navigates to a new location,
  // to check for authentication
  checkAuth: () =>
    localStorage.getItem(PP_ADMIN_TOKEN) ? Promise.resolve() : Promise.reject(),
  // called when the user navigates to a new location,
  // to check for permissions / roles
  getPermissions: () => Promise.resolve(),
};
